import * as React from "react";
import { useState, useEffect } from "react";

import Select from "react-select";
import _ from "lodash";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";

function UpdateRdsConfiguration({
  ecrVersionOptions,
  defaultEcrVersion,
  onChange,
  onReset,
}) {
  const [selectedMccVersion, setSelectedMccVersion] = useState({});
  useEffect(() => {
    if (defaultEcrVersion) {
      setSelectedMccVersion(defaultEcrVersion);
    }
  }, [defaultEcrVersion]);
  const handleECRVersionChange = (key, value, label) => {
    onChange(key, value, label);
  };

  const reset = () => {
    setSelectedMccVersion(defaultEcrVersion);
    onReset();
  };

  return (
    <>
      <Container fluid>
        <Card>
          <Card.Header>
            <Card.Title as="h4">ECR Version Upgrade</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="5">
                <Form.Group>
                  <label>ECR version</label>
                  <Select
                    id="ecr-version"
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="selectedMccVersion"
                    value={selectedMccVersion}
                    required
                    onChange={(object) => {
                      handleECRVersionChange(
                        "ECR_Version",
                        object.value,
                        object.label
                      );
                      setSelectedMccVersion(object);
                    }}
                    options={ecrVersionOptions}
                    placeholder="Select ECR Version"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer>
            <Row>
              <Col md="12">
                <Button
                  variant="default"
                  className="btn-outline"
                  onClick={reset}
                >
                  Reset
                </Button>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default UpdateRdsConfiguration;
